import { create } from 'axios';
import { fetch as nitroFetch } from 'react-native-nitro-fetch';
import { getEnvVars } from '../environment';

const { apiUrl, oAuthConfig } = getEnvVars();

const CONTENT_TYPE_JSON = 'application/json';
const CONTENT_TYPE_FORM_DATA = 'application/x-www-form-urlencoded';

/**
 * Axios instance for general API requests. The interceptor will add the access token to the headers if available.
 */
export const axiosClient = create({
  baseURL: apiUrl,
  adapter: 'fetch',
  withCredentials: false,
  httpVersion: 2,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'RequestVerificationToken',
  headers: {
    'Content-Type': CONTENT_TYPE_JSON,
    'X-Requested-With': 'XMLHttpRequest'
  },
  transformResponse: [], // remove the default JSON.parse transform because it is also added by the proxy
  env: {
    fetch: nitroFetch,
    Request: null!,
    Response: null!
  }
});

/**
 * Separate axios instance for authentication requests to avoid sending the access token in the headers, which can cause issues with some identity providers (e.g., IdentityServer4) when requesting new tokens using a refresh token.
 */
export const authClient = create({
  baseURL: oAuthConfig.issuer,
  adapter: 'fetch',
  withCredentials: false,
  headers: {
    'Content-Type': CONTENT_TYPE_FORM_DATA,
    'X-Requested-With': 'XMLHttpRequest'
  },
  env: {
    fetch: nitroFetch,
    Request: null!,
    Response: null!
  }
});
